import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReference: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"reference, books, study, library, knowledge"} maskId="square-filled-radius-0-stroke-1-IconReference"><path fillRule="evenodd" clipRule="evenodd" d="M20 22H6C4.89543 22 4 21.1046 4 20V4.5C4 3.11929 5.11929 2 6.5 2H20V22ZM6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H19V19H6ZM6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H19V16H6ZM8 6V7H16V6H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconReference;
